import React from 'react';
import { CheckCircle2, AlertTriangle, XCircle, Circle, Clock } from 'lucide-react';
import './ui.css';

// Status is always an icon plus a word, never colour alone.
//   done      green  confirmed complete
//   action    amber  action required (due soon, not started and due)
//   exception red    genuine exception (overdue, failed, expired)
//   neutral   grey   not started, in progress
export const STATUS_KINDS = {
  done:      { icon: CheckCircle2,  className: 'status-chip--done' },
  action:    { icon: AlertTriangle, className: 'status-chip--action' },
  exception: { icon: XCircle,       className: 'status-chip--exception' },
  neutral:   { icon: Circle,        className: 'status-chip--neutral' },
  pending:   { icon: Clock,         className: 'status-chip--neutral' },
};

export default function StatusChip({ kind = 'neutral', children }) {
  const { icon: Icon, className } = STATUS_KINDS[kind] || STATUS_KINDS.neutral;
  return (
    <span className={`status-chip ${className}`}>
      <Icon size={14} strokeWidth={2} aria-hidden="true" />
      <span>{children}</span>
    </span>
  );
}
